import { Button, LinkButton } from '@moniebook-web/components/atoms/button';
import { Body, Title } from '@moniebook-web/components/atoms/typography';
import { FullScreenModal } from '@moniebook-web/components/molecules/full-screen-modal';
import { QuestionLine } from '@moniebook-web/icons-v2/system/question-line';
import { baseConfig, mergeClassNames } from '@moniebook-web/utils';
import { BusinessBrand } from '../../molecules';
import { OnboardingLayout } from '../onboarding-layout';
import { FullSyncProgressIndicator } from './progress-indicator';

export interface RegisterSetupProps {
    isOpen: boolean;
    onClose: () => void;
    syncPercentage: number;
    syncError?: boolean;
    onResume?: VoidFunction;
}

export function RegisterSetup(props: Readonly<RegisterSetupProps>) {
    const { isOpen, onClose, syncPercentage, syncError, onResume } = props;

    return (
        <FullScreenModal isOpen={isOpen} onClose={onClose}>
            <OnboardingLayout
                actions={
                    <div>
                        <LinkButton
                            theme='tertiary'
                            className='!rounded-full px-12'
                            to={baseConfig.MONIEBOOK_CUSTOMER_HELP_URL}
                            label='Get help'
                            target='_blank'
                            rel='noopener noreferrer'
                            size='small'
                            leftIcon={<QuestionLine />}
                        />
                    </div>
                }>
                <section className='mx-auto flex size-full flex-col items-center justify-between gap-28 text-center font-sans'>
                    <div className='mt-8vh'>
                        <BusinessBrand />
                    </div>

                    {syncError ? (
                        <div
                            className={mergeClassNames(
                                'mb-40 flex flex-col items-center gap-10',
                            )}>
                            <img
                                className='mx-auto mb-24 h-15vh max-h-140 min-h-90 w-auto'
                                src='/illustrations/hourglass.svg'
                                alt='Error'
                            />

                            <Title
                                variant='title'
                                as='h2'
                                className='mb-20 font-general-sans text-22 font-semibold leading-none text-content-heading-default'>
                                Sync failed
                            </Title>

                            <Body className='text-base font-normal leading-none text-content-subtext-default'>
                                Your progress has been saved. You can resume
                                from where you left off.
                            </Body>

                            <Button
                                label='Resume'
                                className='w-fit'
                                onClick={onResume}
                            />
                        </div>
                    ) : (
                        <div className='flex flex-col'>
                            <img
                                className='mx-auto mb-24 h-15vh max-h-140 min-h-90 w-auto'
                                src='/illustrations/hourglass.svg'
                                alt='Loading...'
                            />

                            <Title
                                variant='title'
                                as='h2'
                                className='mb-20 font-general-sans text-22 font-semibold leading-none text-content-heading-default'>
                                Hold on while we get everything into place
                            </Title>

                            <Body className='text-base font-normal leading-none text-content-subtext-default'>
                                Syncing your register with the dashboard...
                            </Body>
                        </div>
                    )}

                    {syncError ? (
                        <div />
                    ) : (
                        <FullSyncProgressIndicator
                            syncPercentage={syncPercentage}
                        />
                    )}
                </section>
            </OnboardingLayout>
        </FullScreenModal>
    );
}
